import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61857853"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-card-body is-flex-direction-column" }
const _hoisted_2 = { class: "is-full-width mb-4" }
const _hoisted_3 = { class: "is-flex is-justify-content-space-between" }
const _hoisted_4 = { class: "title-five" }
const _hoisted_5 = { class: "is-full-width mt-1" }
const _hoisted_6 = { class: "modal-card-foot" }
const _hoisted_7 = { class: "is-flex is-full-width is-justify-content-flex-end" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]

import { toRef } from "vue"
import { useComposableForEsc } from "./useComposableForEsc"


export default /*#__PURE__*/_defineComponent({
  __name: 'BulmaSubmitModal',
  props: {
  isActive: Boolean,
  canSubmit: {
    type: Boolean,
    default: true
  },
  hideClose: Boolean,
  isLoading: Boolean,
  isSmall: Boolean
},
  emits: ['close', 'cancel', 'submit'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

useComposableForEsc({
  isActive: toRef(props, 'isActive'),
  dismissFunction: () => emit('close')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'is-active': __props.isActive }, "modal"])
  }, [
    _createElementVNode("div", {
      class: "modal-background",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
    }),
    _createElementVNode("div", {
      class: _normalizeClass(["modal-card", { 'is-small': __props.isSmall }])
    }, [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("section", _hoisted_2, [
          _createElementVNode("article", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, [
              _renderSlot(_ctx.$slots, "title")
            ]),
            (!__props.hideClose)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "delete ml-1",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("section", _hoisted_5, [
          _renderSlot(_ctx.$slots, "content")
        ])
      ]),
      _createElementVNode("footer", _hoisted_6, [
        _renderSlot(_ctx.$slots, "footer", {}, () => [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              disabled: __props.isLoading,
              class: "button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('cancel')))
            }, _toDisplayString(_ctx.$t('cancel')), 9, _hoisted_8),
            _renderSlot(_ctx.$slots, "submitButton", {}, () => [
              _createElementVNode("button", {
                disabled: !__props.canSubmit || __props.isLoading,
                class: "button is-success",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('submit')))
              }, _toDisplayString(_ctx.$t('submit')), 9, _hoisted_9)
            ])
          ])
        ])
      ])
    ], 2)
  ], 2))
}
}

})